import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card,Image } from "react-bootstrap";
import { IoIosArrowDown } from "react-icons/io";
import "./banner.scss";
import { Ward } from "../../../../../assets/images";
import Lottie from "react-lottie-player";
import { Handshake } from "../../../../../assets/images/index";
import { Convenient } from "../../../../../assets/images/index";
import { fetchApi } from "../../../../../service/services";
import ContentShimmer from "react-content-shimmer";
import { Link } from "react-router-dom";

interface BannerItem {
  id: number;
  acf: {
    flyer_upload: string;
  };
}


export const BannerCard = () => {

  const [bannerFlyer, setBannerFlyer] = useState<BannerItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hovered, setHovered] = useState(false);
  const animationData = hovered ? Convenient : Handshake;


  useEffect(() => {
    fetchApi('banner_wishlist')
      .then((data) => {
        setBannerFlyer(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }, []);


  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  if (isLoading) {
    // Loading state
    return (
      <Container>
        <ContentShimmer
          style={{ marginTop: "1rem", width: "w-100", height: "500px" }}
          rounded={"10px"}
        />
      </Container>
    );
  } else if (!isLoading && Object.keys(bannerFlyer).length === 0) {
    return (
        <Container fluid id="banner-section">
          <Row className="banner mt-5 p-5 position-relative">
            <Col
              className="banner-col-1 p-5"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-once="false"
              data-aos-anchor-placement="top-center"
            >
              <div className="banner-col-1-text fw-bold text-white">
                <p className="fw-bold text-break banner-text">
                  Make a wish <span className="fw-light">let your</span>
                </p>
                <p className="fw-light banner-text text-break">
                  {" "}
                  buddies sort you out
                </p>
                <p className="fw-bold banner-text text-break">
                  <span className="fw-light">with </span>Pamo wishlist!
                </p>
              </div>
              <div className="text-white banner-text-sub fw-bold fs-4">
                <span>That's the Pamo way!</span>
              </div>
              <div className=" d-flex  flex-wrap btn-ward-section flex-md-row  position-relative align-items-center">
                <div className="order-md-1">
                  <Link to="https://bit.ly/PamoApp">
                  <Button
                    variant="info"
                    className=" magic-ward-btn fw-bold  text-white p-4 text-left w-100"
                  >
                    Make a wish
                  </Button>{" "}
                  </Link>
                </div>
                <div className=" magic-ward order-md-2">
                  <Lottie
                    loop
                    animationData={Ward}
                    play
                    style={{ width: "140px", height: "100%" }}
                    className="animate-lottie"
                  />
                </div>
                {/* <div className="order-md-3 link">
                  <a
                    href="https://bit.ly/PamoApp"
                    className="text-white fw-bold text-link text-decoration-underline mx-3"
                  >
                    {" "}
                    How to make your first wish
                  </a>
                </div> */}
              </div>
            </Col>
            <Col className="banner-col-2 mt-5  position-relative">
              <div className="background-image-col-wish">
                <Card className="card-hover p-3 ">
                  <Card.Body className="position-relative">
                    <div className=" rounded-circle text-end">
                      <div className="rounded-circle bg-info spot d-inline-block p-2"></div>
                    </div>
                    {/* <div className="alternating-images-on-hover"></div> */}
                    <div className="">
                      <Lottie
                        loop
                        animationData={animationData}
                        play={!hovered}
                        className="handshake"
                        // onMouseEnter={handleMouseEnter}
                        // onMouseLeave={handleMouseLeave}
                      />
                    </div>
                  </Card.Body>
                  <Card.Footer className="card-on-hover-footer text-center">
                    post made!
                  </Card.Footer>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
  
    );
  } else {
    return (
      <Container id="promo-section">
        {bannerFlyer.map((item, key) => (
          <div className="promo-banner" key={key}>
            <Image
              className="flyer"
              src={item?.acf?.flyer_upload}
              key={item?.id}
            />
          </div>
        ))}
      </Container>
    );
  }

  
};
